import { ItemCard } from "@/components/ItemCard";
import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import { useActiveProject } from "@/features/project/ActiveProject";
import { linkOutIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { PaddedContainer, SectionContainer } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { WorkOrderDetails } from "./WorkOrderDetails";

export const WorkOrdersSection = ({ editable }: { editable: boolean }) => {
  const { opportunity } = useActiveProject();

  const serviceWorkOrders =
    opportunity?.serviceWorkOrders?.serviceWorkOrderInfo ?? [];
  const workOrderCount = serviceWorkOrders.length;

  if (workOrderCount === 0) {
    return null;
  }

  return (
    <PaddedContainer>
      <SectionContainer>
        <ActionTitle
          title={`${t(
            workOrderCount === 1 ? "label.work_order" : "label.work_orders"
          )} (${workOrderCount})`}
        />
        {serviceWorkOrders.map((workOrder, index) => {
          const isDisabled =
            !import.meta.env.VITE__SALESFORCE_BASEURL ||
            !workOrder.workOrderExternalId;

          const link = workOrder.id
            ? `${import.meta.env.VITE__SALESFORCE_BASEURL}/${workOrder.workOrderExternalId}`
            : undefined;

          return (
            <ItemCard
              key={workOrder.id ?? index}
              editable={editable}
              hideImage={true}
              details={<WorkOrderDetails workOrder={workOrder} />}
              actions={[
                {
                  id: `open-link-button__workOrder-${workOrder.id}`,
                  title: t("action.open_in_salesforce"),
                  text: t("action.open_in_salesforce"),
                  icon: linkOutIcon,
                  iconPosition: "trailing",
                  disabled: isDisabled,
                  href: isDisabled ? undefined : link,
                  newWindow: true,
                  onClick: () => {
                    trackAnalytics("open_work_order_in_salesforce");
                  },
                },
              ]}
            />
          );
        })}
      </SectionContainer>
    </PaddedContainer>
  );
};
